interface options {
  trigger: string;
}

export function ClipBord(obj: options) {
  class ClipBord {
    triggers: NodeListOf<Element>;
    body: HTMLBodyElement;

    constructor() {
      this.triggers = document.querySelectorAll(`.${obj.trigger}`);
      this.body = document.querySelector('body');
      this.init();
    }

    init() {
      if(this.triggers.length === 0) return;
      console.log(this.triggers);
      Array.prototype.forEach.call(this.triggers, (trigger) => {
        this.clipbord(trigger);
      });
    }

    clipbord(trigger) {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const url = location.href;
        console.log(url);
        navigator.clipboard.writeText(url);
        this.body.insertAdjacentHTML('beforeend', '<div class="o-copy-ok">URLをコピーしました</div>');
  
        setTimeout(function () {
          const copyOk = document.querySelector('.o-copy-ok');
          copyOk.classList.add("is-delete");
          setTimeout(function () {
            copyOk.remove();
          }, 1000);
        }, 1000);
      });
    }
  }

  new ClipBord();
}